export default "__VITE_ASSET__86b98040__"